import _calcTc from "./eventGroups/calcTc.js";
import _addIncode from "./special/addIncode.js";
import _applyWindowOffsets from "./special/applyWindowOffsets.js";
import _defaults from "../lib/defaults.js";
import _encoder from "../profiles/index.js";
const encoder = _encoder;
const defaults = _defaults;
const applyWindowOffsets = _applyWindowOffsets;
const addIncode = _addIncode;
const calcTc = _calcTc;
export default (async function (eventGroups, options = new defaults.options(), qcReport = null) {
  if (encoder[options.profile]) {
    // console.log(JSON.stringify(eventGroups, null, 2));
    //console.log(options);
    let output;
    //Check if EventGroups is an array or single object

    //console.log(eventGroups.length);
    if (!Array.isArray(eventGroups)) {
      eventGroups = [eventGroups];
    }
    eventGroups.forEach(eventGroup => {
      // eventGroup = tcRound(eventGroup, options.frameRate, options.dropFrame);
      eventGroup = calcTc(eventGroup, options.frameRate, options.dropFrame, options.incode);
      eventGroup = addIncode(eventGroup, options);
      eventGroup = applyWindowOffsets(eventGroup, options.window);
      eventGroup = encoder[options.profile].preProcess.encode(eventGroup, options);
    });
    if (options.profile === "macCaptionAdvanced" || options.profile === "sceneristAdvanced" || options.profile === "vancData") {
      output = await encoder[options.profile].encode(eventGroups, options, qcReport);
    } else {
      output = await encoder[options.profile].encode(eventGroups[0], options, qcReport);
    }
    return encoder[options.profile].postProcess.encode(output, options);
  } else {
    throw new Error(`Target profile [${options.profile}] does not exist. Please ensure name matches a supported encoding profile. Profile names are case-sensitive.`);
  }
});